import { render, staticRenderFns } from "./FormuleOptions.vue?vue&type=template&id=5634abfe&"
import script from "./FormuleOptions.vue?vue&type=script&lang=js&"
export * from "./FormuleOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports